import Fader from '@Shared/Fader';
import Icon from '@Shared/Icon';
import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

interface Props {
  show: boolean,
}

const GetStartedSubmit: React.FC<Props> = (props) => {

  return props.show ? (
    <Fader>
      <Row style={{ marginTop: -9 }}>
        <Col xs={2} sm={1}></Col>
        <Col xs={10} sm={11}>
          <Form.Group className='form-group'>
            <hr />
            <div style={{ paddingTop: 13 }}>
              <Button type='submit' variant='primary'>
                <Icon name='upload fas' /> Send Request
              </Button>
            </div>
          </Form.Group>
        </Col>
      </Row>
    </Fader>
  ) : null;
}

export default GetStartedSubmit;